export const isNotNullORBlank = (...args) => {
  for (var i = 0; i < args.length; i++) {
    var argument = args[i]
    if (argument == null || argument === '' || argument === undefined) {
      return false
    }
  }
  return true
}

export const clearObject = (obj) => {
  for (var key in obj) {
    if (obj[key] === 'undefinded' || obj[key] == null) {
      delete obj[key]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js